import React, { ReactElement } from 'react';
import { useLocation } from 'react-router-dom';
import { ForgotPasswordForm } from '../organisms';
import CardHeader from '../organisms/CardHeader';

export default function ForgotPassword(): ReactElement {
  const { search } = useLocation();
  const queryString = new URLSearchParams(search);
  const email = queryString.get('email');

  return (
    <div className="h-100">
      <div className="d-flex align-items-center h-100">
        <div className="mx-auto login-box">
          <div className="card">
            <CardHeader />

            <div className="card-body">
              <h1 className="card-title text-center py-1">
                Inserisci la tua email
              </h1>
              <ForgotPasswordForm email={email || undefined} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}